import { ListToFitFieldLayout } from 'Components/Layout/FieldLayout';
import { getWorksheetBatchUpdateDefinition } from 'Components/WorksheetBatchUpdate';
import { WorksheetBatchUpdateQueryInjectedPropsProvider } from 'Components/WorksheetBatchUpdate/Core/WorksheetBatchUpdateQuerySection/WorksheetBatchUpdateQueryInjectedPropsProvider';
import { WorksheetBatchUpdateRefreshButton } from 'Components/WorksheetBatchUpdate/Core/WorksheetBatchUpdateQuerySection/WorksheetBatchUpdateRefreshButton';
import React from 'react';
import { useSelector } from 'react-redux';
import './WorksheetBatchUpdateQuerySection.scss';

const WorksheetBatchUpdateQuerySection: React.FC = () => {
  const typeId = useSelector((state) => state.worksheetBatchUpdate.typeId);
  const { queryFields = {} } = typeId ? getWorksheetBatchUpdateDefinition(typeId) : {};

  return (
    <div className="WorksheetBatchUpdateQuerySection">
      <div className="WorksheetBatchUpdateQuerySection-Fields">
        <WorksheetBatchUpdateQueryInjectedPropsProvider>
          <ListToFitFieldLayout>
            {Object.entries(queryFields)
              .filter(([_, f]) => !f.hidden?.())
              .map(([k, f]) =>
                React.cloneElement(f.entryComponent!, {
                  name: k,
                  horizontal: true,
                  key: k,
                })
              )}
          </ListToFitFieldLayout>
        </WorksheetBatchUpdateQueryInjectedPropsProvider>
      </div>
      <WorksheetBatchUpdateRefreshButton />
    </div>
  );
};

export default WorksheetBatchUpdateQuerySection;
export { WorksheetBatchUpdateQuerySection };
